import { Link } from "react-router-dom";
import { blogPosts } from "../../data/blogPosts";
import "./BlogList.css";

function BlogList() {
  return (
    <div className="blog-container">
      <div className="blog-list-container">
        <h1 className="blog-heading">MedaHealth Associates Blog</h1>
        <p className="blog-subheading">
          Understand your options, protect your future.
        </p>

        <div className="blog-grid">
          {blogPosts.map((post) => (
            <Link
              to={`/blog/${post.slug}`}
              key={post.slug}
              className="blog-card"
            >
              <div className="blog-image-wrapper">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-card-content">
                <h2>{post.title}</h2>
                <p>{post.description}</p>
                <span className="read-more">Read More →</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogList;
